import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=11c8122d&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c8122d')) {
      api.createRecord('11c8122d', component.options)
    } else {
      api.reload('11c8122d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=11c8122d&", function () {
      api.rerender('11c8122d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/mda/edit.vue"
export default component.exports